import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LanguageService } from '@box-core/services/language.service';
import { Language, SeoOptions } from '@box-types';
import { ConfigurationService, AnalyticsService, LoaderService, SEOService } from '@box-core/services';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { QueryParamsService } from '@box-core/services/query-params.service';

@Component({
  selector: 'account-settings-language',
  templateUrl: './account-settings-language.component.html',
  styleUrls: ['./account-settings-language.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountSettingsLanguageComponent implements OnInit {
  public languages: Language[];
  public selectedLanguageCode: string;

  constructor(
    private configurationService: ConfigurationService,
    private languageService: LanguageService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private queryParamsService: QueryParamsService,
    private analyticsService: AnalyticsService,
    private loaderService: LoaderService,
    private seoService: SEOService
  ) {}

  ngOnInit(): void {
    this.setMetaTags();
    this.languages = this.configurationService.getConfiguration().languages;
    this.selectedLanguageCode = this.languageService.getLanguageCode();
    this.changeDetectorRef.detectChanges();
  }

  public onLanguagePreferenceSelection(language: Language): void {
    if (language.languageCode === this.selectedLanguageCode) return;
    this.languageService.saveLanguageCodeToStorage(language.languageCode);
    this.setRemoteLanguage(language);
    this.triggerAnalyticsEvent(language);
    this.selectedLanguageCode = language.languageCode;
    this.changeDetectorRef.detectChanges();
  }

  private setRemoteLanguage(language: Language): void {
    this.loaderService.setState(true);
    this.languageService
      .setUserLanguage(language.languageCode)
      .pipe(finalize(() => this.loaderService.setState(false)))
      .subscribe(() => this.queryParamsService.addQueryParamsAndRefresh({ lang: language.languageCode }));
  }

  private triggerAnalyticsEvent(language: Language): void {
    this.analyticsService.addGACustomEvent('language_changed_profile', { language: language.languageCode });
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.route.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
